import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

const normalizer = createShapeNormalizer({
	type: 'object',
	shape: {
		isEnabled: { type: 'boolean' },
		experiment: { type: 'string' },
	},
});

export const FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS = createFcmConfig(
	'starter_experience_share_recommendations',
	{
		normalizer: createJsonNormalizer(normalizer),
		defaultValue: {
			isEnabled: false,
			experiment: '',
		},
	},
);
